import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { SmtpConfig } from "../../core/model/smtp-config";
import { SmtpConfigService } from "../../core/service/smtp-config.service";

@Component({
  selector: "app-edit-smtp-config",
  templateUrl: "./edit-smtp-config.component.html",
  styleUrls: ["./edit-smtp-config.component.scss"],
})
export class EditSmtpConfigComponent implements OnInit {
  @Input()
  set smtp(value: SmtpConfig) {
    if (value) {
      this._smtp = { ...value };
      this.loading = false;
      this.cdr.detectChanges();
    }
  }
  get smtp(): SmtpConfig {
    return this._smtp;
  }

  private _smtp: SmtpConfig;

  form2: FormGroup;
  pressButton: Boolean = false;
  loading = true;

  constructor(
    private _smtpConfigService: SmtpConfigService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      host: [null, Validators.compose([Validators.required])],
      port: [null, Validators.compose([Validators.required])],
      starttls: [null, Validators.compose([Validators.required])],
      username: [null, Validators.compose([Validators.required])],
      password: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {}

  save(): void {
    this.pressButton = true;
    this._smtpConfigService
      .putSmtp(this.smtp)
      .pipe(first())
      .subscribe(
        () => {
          this.pressButton = false;
          this.activeModal.close(this.smtp);
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
